import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { GenericControl } from "../../UI.BaseControls/GenericControl";
import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { DropDownMenuItem } from "./DropDownMenuItem";

export class DropDownButtonItem extends DropDownMenuItem {
    public isClickable: boolean = false;

    public get buttons(): HTMLElement[] {
        return Array.from(this.querySelectorAll(".itemButton")) as HTMLElement[];
    }

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    protected override _constructor(): void {
        super._constructor();

        this.visible = true;
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "ButtonItem");

        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }

        this._setListener();
    }

    public addItem(locKey: string, clickAction: (e: MouseEvent) => void, additionalClass: string = ""): void {
        const button = createElement({ type: "button", classes: ["btn", "primary", additionalClass] });

        Localization.addLocData(button, locKey);
        GenericControl.registerEventListener(button, "click", (e: MouseEvent) => {
            if (button.classList.contains("Disabled"))
                return;
            e.stopImmediatePropagation(); // EventHelper způsobuje okamžité zavření menu svou cancelled událostí
            clickAction(e);
        });

        this.appendChild(button);
    }

    protected override _setListener(): void {
        this.registerEventListener("click", (e: MouseEvent) => e.stopImmediatePropagation());
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownButtonItem", DropDownButtonItem);
